module.exports = __webpack_public_path__ + "static/img/EW6A0022.5b80c9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/EW6A0022.jpg
// module id = sCGv
// module chunks = 39